<template>
  <div>
    <CardedForm
      ref="owner_register_business_form_ref"
      id="owner_register_business_form"
      title="_"
      :is_loading="is_loading"
      @on-submit-form="submit"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
    >
      <CardedSectionHeader
        icon="mdi-form-select"
        label="Basic Information"
        id="owner_register_business_basic_info_details"
      ></CardedSectionHeader>
      <br />
      <v-row no-gutterss class="pa-0 mb-0">
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <TextField
            v-model="form.name"
            :validation_rules="form_validations.name"
            label="Name Of Business"
            icon="mdi-pen-plus"
            :disabled="is_loading"
          ></TextField>
        </v-col>
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <ImageField
            label="Business Logo"
            icon="mdi-camera"
            :disabled="is_loading"
            folder="businesslogoes"
            @on-hide-loader="hide_loader"
            @on-show-loader="show_loader"
            @on-success="on_finished_file_upload"
            @on-error="on_file_upload_errors"
            ref="logo_file_uploader"
            :required="false"
            empty_file_error="No logo image choosen for the logo"
            :default_value="default_thumbnail"
          >
          </ImageField>
        </v-col>
      </v-row>

      <v-row no-gutterss class="pa-0 mb-0">
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <TextField
            v-model="form.tag_line"
            :validation_rules="form_validations.tag_line"
            label="Tag Line (e.g Our customer is our priority)"
            icon="mdi-pen-plus"
            :disabled="is_loading"
          ></TextField>
        </v-col>
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="form.is_local_company"
            :options="local_companies_options"
            :small_chips="false"
            :validation_rules="form_validations.is_local_company"
            label="Company Origin"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <SelectField
            v-model="form.is_main_branch"
            :options="branch_types"
            :small_chips="false"
            :validation_rules="form_validations.is_main_branch"
            label="Branch Type"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
            @change="set_branch"
          ></SelectField>
        </v-col>
        <v-col>
          <SelectField
            v-model="form.is_branch_of_id"
            :options="my_companies"
            :small_chips="false"
            :validation_rules="form_validations.is_branch_of_id"
            label="Choose Main Branch"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
      </v-row>

      <TextArea
        v-model="form.description"
        :validation_rules="form_validations.description"
        label="Business Description"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextArea>

      <!-- <v-divider></v-divider> -->
      <CardedSectionHeader
        icon="mdi-form-select"
        label="Contact Information"
        id="owner_register_business_contacts_info_details"
      ></CardedSectionHeader>
      <br />
      <v-row no-gutterss class="pa-0 mb-0">
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <TextField
            v-model="form.office_phone_number1"
            :validation_rules="form_validations.office_phone_number1"
            label="Officee Phone Number"
            icon="mdi-pen-plus"
            :disabled="is_loading"
          ></TextField>
        </v-col>
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <TextField
            v-model="form.mobile_phone_number1"
            :validation_rules="form_validations.mobile_phone_number1"
            label="Mobile Phone Number"
            icon="mdi-pen-plus"
            :disabled="is_loading"
          ></TextField>
        </v-col>
      </v-row>
      <v-row no-gutterss class="pa-0 mb-0">
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <TextField
            v-model="form.email_address_1"
            :validation_rules="form_validations.email_address_1"
            label="Business Email Address"
            icon="mdi-pen-plus"
            :disabled="is_loading"
          ></TextField>
        </v-col>
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <TextField
            v-model="form.website_1"
            :validation_rules="form_validations.website_1"
            label="Business Website URL (e.g https://www.mybusiness.com )"
            icon="mdi-pen-plus"
            :disabled="is_loading"
          ></TextField>
        </v-col>
      </v-row>
      <CardedSectionHeader
        icon="mdi-form-select"
        label="Sub Categories & Categories"
        id="owner_register_business_subcategory_info_details"
      ></CardedSectionHeader>
      <v-row no-gutterss class="pa-0 mb-0">
        <v-col cols="4" no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="category_id"
            :options="categories"
            :small_chips="false"
            :validation_rules="form_validations.category_id"
            label="Category"
            icon="mdi-pen-plus"
            :disabled="disable_category_inputs"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
        <v-col cols="4" no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="sub_category_id"
            :options="sub_categories"
            :small_chips="false"
            :validation_rules="form_validations.sub_category_id"
            label="Sub Category"
            icon="mdi-pen-plus"
            :disabled="disable_category_inputs"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
        <v-col cols="2" no-gutters class="pb-0 pt-0 mb-0">
          <v-btn
            class="ma-1 mobile-app-bar-btn mt-2"
            dense
            rounded
            outlined
            color="success"
            @click="add_category_to_cart"
            :disabled="disable_category_inputs"
          >
            <v-icon left class="success--text">mdi-plus</v-icon> Add Category
          </v-btn>
        </v-col>
      </v-row>
      <div class="mb-5">
        <CardedTable
          :has_margin="false"
          :show_search="false"
          :height="200"
          :show_header_bar="false"
          :items="selected_categories"
          :headers="selected_categories_headers"
          :show_footer="false"
        >
          <template v-slot:[`item.icon`]="{ item }">
            <v-icon>{{ item.icon }}</v-icon>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              @click="on_remove_selected_sub_category_item(item)"
              x-small
              rounded
              text
              color="red"
            >
              <v-icon>mdi-cross</v-icon>
            </v-btn>
          </template>
        </CardedTable>
      </div>
      <CardedSectionHeader
        icon="mdi-form-select"
        label="Location Information"
        id="owner_register_business_location_info_details"
      ></CardedSectionHeader>
      <TextArea
        v-model="form.manual_directions"
        :validation_rules="form_validations.manual_directions"
        label="Directions to business (e.g How can clients find your business)"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextArea>
      <v-row no-gutterss class="pa-0 mb-0">
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="form.district_id"
            :options="districts"
            :small_chips="false"
            :validation_rules="form_validations.district_id"
            label="District"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="form.city_id"
            :options="cities"
            :small_chips="false"
            :validation_rules="form_validations.city_id"
            label="City"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
      </v-row>
      <v-row no-gutterss class="pa-0 mb-0">
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="form.ward_id"
            :options="wards"
            :small_chips="false"
            :validation_rules="form_validations.ward_id"
            label="Ward"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="form.street_id"
            :options="streets"
            :small_chips="false"
            :validation_rules="form_validations.street_id"
            label="Street"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
      </v-row>
      <TextField
        v-model="form.physical_address"
        :validation_rules="form_validations.physical_address"
        label="Enter Physical Address: (e.g plot 22211 phase 4, Gaborone)"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextField>
    </CardedForm>
  </div>
</template>

<script>
import CardedForm from "../../../components/CardedForm";
import TextField from "../../../components/TextField";
import TextArea from "../../../components/TextArea";
import ImageField from "../../../components/ImageField";
import SelectField from "../../../components/SelectField";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedTable from "../../../components/CardedTable";
export default {
  name: "OwnerBusinessesRegister",
  components: {
    CardedForm,
    TextField,
    ImageField,
    SelectField,
    TextArea,
    CardedSectionHeader,
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_editing: {
      type: Boolean,
      default: false,
    },
    is_added_by_admin: {
      type: Boolean,
      default: false,
    },
    owner: {
      type: Object,
      default: function(){
        return null;
      },
    },
  },
  data: () => {
    return {
      _user: null,
      errors: [],
      message: "",
      form: {
        name: "",
        tag_line: "",
        description: "",
        logo: "",
        banner: "",
        is_local_company: 1,
        is_main_branch: 0,
        is_branch_of_id: -1,
        office_phone_number1: "",
        office_phone_number2: "",
        mobile_phone_number1: "",
        mobile_phone_number2: "",
        email_address_1: "",
        email_address_2: "",
        email_address_3: "",
        website_1: "",
        website_2: "",
        website_3: "",
        fax_number: "",
        pobox_number: "",
        facebook_link: "",
        twitter_link: "",
        instagram_link: "",
        youtube_link: "",
        linked_link: "",
        whatsapp_link: "",
        manual_directions: "",
        physical_address: "",
        lat: 0,
        lng: 0,
        time_zone: "",
        district_id: 0,
        city_id: 0,
        ward_id: 0,
        street_id: 0,
        tags: "",
        monday_openning_time_display: "",
        monday_closing_time_display: "",
        tuesday_openning_time_display: "",
        tuesday_closing_time_display: "",
        wednesday_openning_time_display: "",
        wednesday_closing_time_display: "",
        thursday_openning_time_display: "",
        thursday_closing_time_display: "",
        friday_openning_time_display: "",
        friday_closing_time_display: "",
        saturday_openning_time_display: "",
        saturday_closing_time_display: "",
        sunday_openning_time_display: "",
        sunday_closing_time_display: "",
        hollidays_openning_time_display: "",
        hollidays_closing_time_display: "",
      },
      form_validations: {
        name: [
          Utils.validate.is_required("Business name is required"),
          Utils.validate.min_max_length(
            3,
            50,
            "Business name should be between 3 and 50 characters "
          ),
        ],
        tag_line: [
          Utils.validate.max_length(
            150,
            "Tag line should be less than 150 characters"
          ),
        ],
        is_local_company: [],
        is_main_branch: [],
        is_branch_of_id: [],
        description: [
          Utils.validate.max_length(
            400,
            "Your business description should be less than 400 characters"
          ),
        ],
        office_phone_number1: [
          Utils.validate.if_provided_phone_number(
            "Please provide a valid officcee phone number",
            true
          ),
        ],
        mobile_phone_number1: [
          Utils.validate.if_provided_phone_number(
            "Please enter a valid phone number"
          ),
        ],
        email_address_1: [
          Utils.validate.if_provided_email_format(
            "Please enter a valide email address"
          ),
        ],
        website_1: [
          Utils.validate.max_length(
            100,
            "Website URL should be less than 100 characters long"
          ),
        ],
        category_id: [
          Utils.validate.is_required("Please select a business category"),
        ],
        sub_category_id: [
          //Utils.validate.is_required("Please select a sub category"),
        ],
        manual_directions: [
          Utils.validate.max_length(
            200,
            "Directions to your business should be less than 200 characters"
          ),
        ],
        district_id: [
          Utils.validate.is_required(
            "Please select the district where your business is located"
          ),
        ],
        city_id: [],
        ward_id: [],
        street_id: [],
        physical_address: [
          Utils.validate.max_length(
            150,
            "Your business physicall address should be less than 150 characters"
          ),
        ],
      },
      default_thumbnail: Utils.default_business_logo,
      categories: [],
      selected_categories: [],
      category_id: null,
      sub_category_id: null,
      is_processing_categories: false,
      selected_categories_headers: [
        { text: "", value: "icon" },
        { text: "Category", value: "category.name" },
        { text: "Sub Category", value: "name" },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
      my_companies: [],
      districts: [],
      branch_types: [
        { id: 0, name: "No Branch" },
        { id: 1, name: "Main Branch" },
        { id: 2, name: "Is Sub Branch" },
      ],
      local_companies_options: [
        { id: 1, name: "Local Company" },
        { id: 0, name: "Foreign Company" },
      ],
    };
  },
  methods: {
    on_auto_fill() {
      var rnd = Math.ceil(Math.random() * 456);
      this.form.name = "Business_" + rnd;
      this.form.tag_line = "Our Super Business " + rnd;
      this.form.description =
        "This business is very good at providing quality services ";
      this.form.logo = Utils.default_business_logo;
      this.form.banner = "";
      this.form.is_local_company = 1;
      this.form.is_main_branch = 0;
      this.form.is_branch_of_id = -1;
      this.form.office_phone_number1 = "0356781" + rnd;
      this.form.office_phone_number2 = "";
      this.form.mobile_phone_number1 = "773931" + rnd;
      this.form.mobile_phone_number2 = "";
      this.form.email_address_1 = "mycoolbusiness" + rnd + "@coolbusiness.com";
      this.form.email_address_2 = "";
      this.form.email_address_3 = "";
      this.form.website_1 = "https://www.mycoolbusiness" + rnd + ".com";
      this.form.website_2 = "";
      this.form.website_3 = "";
      this.form.fax_number = "";
      this.form.pobox_number = "";
      this.form.facebook_link = "";
      this.form.twitter_link = "";
      this.form.instagram_link = "";
      this.form.youtube_link = "";
      this.form.linked_link = "";
      this.form.whatsapp_link = "";
      this.form.manual_directions =
        "Opposite Game city in pahse 4, after the football pitch " +
        rnd +
        " on plot 22" +
        rnd +
        ", before the tech shop";
      this.form.physical_address = "plot 22" + rnd + ", phase 4 Gaborone";
      this.form.lat = 0;
      this.form.lng = 0;
      this.form.time_zone = "";
      var di = 0;
      var ci = 0;
      var wi = 0;
      var si = 0;
      if (this.districts.length > 0) {
        di = this.districts[0].id;
        if (this.districts[0].cities.length > 0) {
          ci = this.districts[0].cities[0].id;
        }
        if (this.districts[0].wards.length > 0) {
          wi = this.districts[0].wards[0].id;
          if (this.districts[0].wards[0].streets.length > 0) {
            si = this.districts[0].wards[0].streets[0].id;
          }
        }
      }
      this.form.district_id = di;
      this.form.city_id = ci;
      this.form.ward_id = wi;
      this.form.street_id = 0;
      this.form.tags = "";
      this.form.monday_openning_time_display = "";
      this.form.monday_closing_time_display = "";
      this.form.tuesday_openning_time_display = "";
      this.form.tuesday_closing_time_display = "";
      this.form.wednesday_openning_time_display = "";
      this.form.wednesday_closing_time_display = "";
      this.form.thursday_openning_time_display = "";
      this.form.thursday_closing_time_display = "";
      this.form.friday_openning_time_display = "";
      this.form.friday_closing_time_display = "";
      this.form.saturday_openning_time_display = "";
      this.form.saturday_closing_time_display = "";
      this.form.sunday_openning_time_display = "";
      this.form.sunday_closing_time_display = "";
      this.form.hollidays_openning_time_display = "";
      this.form.hollidays_closing_time_display = "";
      this.selected_categories = [];
      if (
        this.categories.length > 0 &&
        this.categories[0].sub_categories.length > 0
      ) {
        this.selected_categories.push({
          ...this.categories[0].sub_categories[0],
          category: this.categories[0],
        });
      }
      this.errors = [];
      this.message = "";
      this.$refs.owner_register_business_form_ref.on_clear_validations();
    },
    init_form() {
      this.form.name = "";
      this.form.tag_line = "";
      this.form.description = "";
      this.form.logo = "";
      this.form.banner = "";
      this.form.is_local_company = 1;
      this.form.is_main_branch = 0;
      this.form.is_branch_of_id = -1;
      this.form.office_phone_number1 = "";
      this.form.office_phone_number2 = "";
      this.form.mobile_phone_number1 = "";
      this.form.mobile_phone_number2 = "";
      this.form.email_address_1 = "";
      this.form.email_address_2 = "";
      this.form.email_address_3 = "";
      this.form.website_1 = "";
      this.form.website_2 = "";
      this.form.website_3 = "";
      this.form.fax_number = "";
      this.form.pobox_number = "";
      this.form.facebook_link = "";
      this.form.twitter_link = "";
      this.form.instagram_link = "";
      this.form.youtube_link = "";
      this.form.linked_link = "";
      this.form.whatsapp_link = "";
      this.form.manual_directions = "";
      this.form.physical_address = "";
      this.form.lat = 0;
      this.form.lng = 0;
      this.form.time_zone = "";
      this.form.district_id = 0;
      this.form.city_id = 0;
      this.form.ward_id = 0;
      this.form.street_id = 0;
      this.form.tags = "";
      this.form.monday_openning_time_display = "";
      this.form.monday_closing_time_display = "";
      this.form.tuesday_openning_time_display = "";
      this.form.tuesday_closing_time_display = "";
      this.form.wednesday_openning_time_display = "";
      this.form.wednesday_closing_time_display = "";
      this.form.thursday_openning_time_display = "";
      this.form.thursday_closing_time_display = "";
      this.form.friday_openning_time_display = "";
      this.form.friday_closing_time_display = "";
      this.form.saturday_openning_time_display = "";
      this.form.saturday_closing_time_display = "";
      this.form.sunday_openning_time_display = "";
      this.form.sunday_closing_time_display = "";
      this.form.hollidays_openning_time_display = "";
      this.form.hollidays_closing_time_display = "";
      this.errors = [];
      this.message = "";
      this.$refs.owner_register_business_form_ref.on_clear_form();
    },
    submit() {
      //upload the logo
      this.$refs.logo_file_uploader.upload_file();
    },
    hide_loader() {
      this.$emit("on-hide-loader");
    },
    show_loader() {
      this.$emit("on-show-loader");
    },
    on_finished_file_upload(file_url) {
      this.thumb_nail = file_url;
      if (this.is_editing == true) {
        this.update_business();
        //console.log("updated business ");
      } else {
        this.post_business();
        //console.log("post business ");
      }
    },
    on_file_upload_errors(errors) {
      this.errors = errors;
      this.$refs.owner_register_business_form_ref.show_error_dialog();
    },
    add_category_to_cart() {
      this.errors = [];
      this.is_processing_categories = true;
      if (this.category_id == null || parseInt(this.category_id == 0)) {
        this.errors.push("Please select a category for the business");
      }
      if (this.sub_category_id == null || parseInt(this.sub_category_id == 0)) {
        this.errors.push("Please select a sub category for the business");
      }
      //make sure that the sub category is not selected twice
      for (var index2 = 0; index2 < this.selected_categories.length; index2++) {
        var selected_sub_category = this.selected_categories[index2];
        if (
          parseInt(this.sub_category_id) == parseInt(selected_sub_category.id)
        ) {
          this.errors.push(
            "Sub Category, " +
              selected_sub_category.name +
              " is already selected"
          );
        }
      }
      //nyd
      //whats the limit, please find out from the project manager (Lorato)
      if (this.selected_categories.length == Utils.sub_categories_limit) {
        this.errors.push(
          "You cannot select more than " +
            Utils.sub_categories_limit +
            " sub categories fo your business"
        );
      }
      if (this.errors.length > 0) {
        this.is_processing_categories = false;
        this.$refs.owner_register_business_form_ref.show_error_dialog();
        return false;
      }

      for (var index = 0; index < this.sub_categories.length; index++) {
        var sub_category = this.sub_categories[index];
        if (parseInt(this.sub_category_id) == parseInt(sub_category.id)) {
          var category = null;
          for (
            var cat_index = 0;
            cat_index < this.categories.length;
            cat_index++
          ) {
            var cat_temp = this.categories[cat_index];
            if (parseInt(this.category_id) == parseInt(cat_temp.id)) {
              category = cat_temp;
              break;
            }
          }
          this.selected_categories.push({
            ...sub_category,
            category: category,
          });
        }
      }

      //nyd
      //improve this cart so that the sub category that is already seleceted is emoved from
      //the drop down, and when a category has no more sub sub cateories it is removed from
      //the drop down, when a user removed a selected sub category then its added back to the
      //drop down and also the category is added back if it was not there in the drop down;

      this.is_processing_categories = false;
      this.sub_category_id = null;
    },
    on_remove_selected_sub_category_item(selected_sub_category) {
      var temp = [];
      for (var index = 0; index < this.selected_categories.length; index++) {
        var selected_category = this.selected_categories[index];
        if (
          parseInt(selected_category.id) == parseInt(selected_sub_category.id)
        ) {
          console.log("his Arthur ", selected_category);
          continue; //skip this one
        }
        temp.push(selected_category);
      }
      this.selected_categories = temp;
    },
    get_register_business_dependencies() {
      ServerClient.Businesses.get_register_business_dependencies(
        {
          user_id: this.owner ? this.owner.id : this._user.id,
        },
        (res) => {
          this.categories = res.categories;
          if (this.categories.length > 0) {
            this.category_id = this.categories[0].id;
            if (this.categories[0].sub_categories.length > 0) {
              this.sub_category_id = this.categories[0].sub_categories[0].id;
            }
          }
          this.my_companies = [
            {
              id: 0,
              name: "Self",
            },
          ].concat(res.businesses);
          this.districts = res.districts;
        },
        (errors) => {
          this.errors = errors;
          this.$refs.owner_register_business_form_ref.show_error_dialog();
        }
      );
    },
    set_branch(values) {
      if (parseInt(values.new_value) == 1) {
        this.form.is_branch_of_id = 0;
        return;
      }
      if (this.my_companies.length > 1) {
        //choose the first company
        this.form.is_branch_of_id = this.my_companies[1].id;
      } else {
        this.form.is_branch_of_id = -1;
      }
    },
    post_business() {
      this.errors = [];
      this.message = "";

      //sub branch cannot be 0 if
      //one choose self for branch type
      if (
        parseInt(this.form.is_main_branch) == 2 &&
        parseInt(this.form.is_branch_of_id) <= 0
      ) {
        this.errors.push(
          "Please select another company as the parent branch of this company"
        );
        this.$refs.owner_register_business_form_ref.show_error_dialog();
        return;
      }

      //nyd
      //one must atleast provide a phone
      //number of office phone number
      var required_va = Utils.validate.is_required("");
      var is_officee_phone_provided = required_va(
        this.form.office_phone_number1
      );
      var is_mobile_phone_provided = required_va(
        this.form.mobile_phone_number1
      );
      if (
        is_officee_phone_provided == false &&
        is_mobile_phone_provided == false
      ) {
        this.errors.push(
          "Please provide a valid office phone number or a valid mobile phone number"
        );
        this.$refs.owner_register_business_form_ref.show_error_dialog();
        return;
      }

      //there should be atleast one category selected
      //for the business
      if (this.selected_categories.length == 0) {
        this.errors.push(
          "Please select atleast one sub category that your business belongs to"
        );
        this.$refs.owner_register_business_form_ref.show_error_dialog();
        return;
      }

      var data = {
        ...this.form,
      };
      //if this.form.is_branch_of_id == -1
      //means no branch choosen may be the same as no branch
      //if this.form.is_branch_of_id == 0 refers to self
      //if this.form.is_branch_of_id > 0 another company
      data.user_id = this._user.id;
      data.is_added_by_admin = 0;
      data.added_by_id = this._user.id;
      data.assigned_by_id = this._user.id; //self assigned
      data.is_assigned_to_owner = 1;
      data.former_owner_id = this._user.id;
      data._date_joined_on = "";
      data._now_joined_on_timestamp = "";
      data._date_assigned_on = "";
      data._now_assigned_on_timestamp = "";
      if (this.is_added_by_admin) {
        data.user_id = this.owner.id;
        data.is_added_by_admin = 1;
        data.former_owner_id = this.owner.id;
      }
      data.is_approved = 0;
      data.is_verified = 0;
      data.verified_on = "1970-01-01";
      data._now_verified_on_timestamp = "";
      data.verified_by_id = 0;
      data.country_id = 1; //botswana
      data.qr_code = "";
      data.views_count = 0;
      data.reviews_count = 0;
      data.rating = 0;
      data.is_local_company_specified = data.is_local_company == 1 ? 1 : 0;
      data.monday_openning_time_value = 0;
      data.monday_closing_time_value = 0;
      data.tuesday_openning_time_value = 0;
      data.tuesday_closing_time_value = 0;
      data.wednesday_closing_time_value = 0;
      data.thursday_openning_time_value = 0;
      data.thursday_closing_time_value = 0;
      data.friday_openning_time_value = 0;
      data.friday_closing_time_value = 0;
      data.saturday_openning_time_value = 0;
      data.saturday_closing_time_value = 0;
      data.sunday_openning_time_value = 0;
      data.sunday_closing_time_value = 0;
      data.hollidays_openning_time_value = 0;
      data.hollidays_closing_time_value = 0;
      data.doc_idcopy_url = "";
      data.doc_cert_incoporation_url = "";
      data.doc_extr_comp_document_url = "";
      data.doc_cert_tax_url = "";
      data.doc_trade_liscence_url = "";
      data.doc_registration_cert_url = "";

      if(data.user_id && parseInt(data.user_id) == 0){
        this.errors.push(
          "The business must have an owner,so please login / create an account to register a business"
        );
        this.$refs.owner_register_business_form_ref.show_error_dialog();
        return;
      }else if(!data.user_id){
        this.errors.push(
          "The business must have an owner,so please login first"
        );
        this.$refs.owner_register_business_form_ref.show_error_dialog();
        return;
      }

      if(data.district_id && parseInt(data.district_id) == 0){
        this.errors.push(
          "Please select the district of this business"
        );
        this.$refs.owner_register_business_form_ref.show_error_dialog();
        return;
      }else if(!data.district_id){
        this.errors.push(
          "Please select a district of this business"
        );
        this.$refs.owner_register_business_form_ref.show_error_dialog();
        return;
      }

      if(data.city_id && parseInt(data.city_id) == 0){
        this.errors.push(
          "Please select the city of this business, if no city, select no city option from the list"
        );
        this.$refs.owner_register_business_form_ref.show_error_dialog();
        return;
      }else if(!data.city_id){
        this.errors.push(
          "Please select a city of this business, if no city, then select the no city option from the list"
        );
        this.$refs.owner_register_business_form_ref.show_error_dialog();
        return;
      }

      if(data.ward_id && parseInt(data.ward_id) == 0){
        this.errors.push(
          "Please select the ward where this business is located"
        );
        this.$refs.owner_register_business_form_ref.show_error_dialog();
        return;
      }else if(!data.ward_id){
        this.errors.push(
          "Please select a ward where this business is located"
        );
        this.$refs.owner_register_business_form_ref.show_error_dialog();
        return;
      }

      if(data.street_id && parseInt(data.street_id) == 0){
        this.errors.push(
          "Please select the street where this business is located"
        );
        this.$refs.owner_register_business_form_ref.show_error_dialog();
        return;
      }else if(!data.street_id){
        this.errors.push(
          "Please select a street where this business is located"
        );
        this.$refs.owner_register_business_form_ref.show_error_dialog();
        return;
      }

      
      ServerClient.Businesses.post_my_business(
        {
          data: data,
          categories: this.selected_categories,
          is_added_by_admin: this.owner != null
        },
        (res) => {
          console.log("add my business res", res);
          this.$refs.owner_register_business_form_ref.on_clear_form();
          this.init_form();
          this.$emit("on-hide-loader");
          this.message =
            "<b>Operation was successfull</b> <br/>  The Business was added successfully";
          this.$refs.owner_register_business_form_ref.show_message_dialog();
        },
        (errors) => {
          this.errors = errors;
          this.$refs.owner_register_business_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
        }
      );
    },
    update_business() {},
    on_hide_message() {
      if (this.is_editing == true) {
        this.$emit("on-success-edit");
      } else {
        this.init_form();
      }
    },
  },
  computed: {
    disable_category_inputs() {
      if (this.is_loading || this.is_processing_categories) {
        return true;
      }
      return false;
    },
    sub_categories() {
      var temp = [];
      for (var index = 0; index < this.categories.length; index++) {
        var cat = this.categories[index];
        if (parseInt(cat.id) == parseInt(this.category_id)) {
          temp = cat.sub_categories;
          break;
        }
      }
      return temp;
    },
    cities() {
      var temp = [];
      for (var index = 0; index < this.districts.length; index++) {
        var district = this.districts[index];
        if (parseInt(district["id"]) == parseInt(this.form.district_id)) {
          temp = district.cities;
          break;
        }
      }
      return temp;
    },
    wards() {
      var temp = [];
      for (var index = 0; index < this.districts.length; index++) {
        var district = this.districts[index];
        if (parseInt(district["id"]) == parseInt(this.form.district_id)) {
          temp = district.wards;
          break;
        }
      }
      return temp;
    },
    streets() {
      var temp = [];
      for (var index = 0; index < this.districts.length; index++) {
        var district = this.districts[index];
        var found = false;
        if (parseInt(district["id"]) == parseInt(this.form.district_id)) {
          var wards = district.wards;
          for (var index2 = 0; index2 < wards.length; index2++) {
            var ward = wards[index2];
            if (parseInt(ward.id) == parseInt(this.form.ward_id)) {
              temp = ward.streets;
              found = true;
              break;
            }
          }
        }
        if (found == true) {
          break;
        }
      }
      return temp;
    },
  },
  mounted() {
    this._user = ServerClient.Login.get_logged_in_user();
    this.get_register_business_dependencies();
  },
};
</script>